import { render } from "./chrome.vue?vue&type=template&id=571a6a64"
import script from "./chrome.vue?vue&type=script&lang=js"
export * from "./chrome.vue?vue&type=script&lang=js"

import "./chrome.vue?vue&type=style&index=0&id=571a6a64&lang=less"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__